"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable no-shadow */
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_redux_1 = require("react-redux");
const b_1 = __importDefault(require("b_"));
const react_2 = require("react");
const selectors_1 = require("src/redux/sagas/selectors");
const actions_1 = require("src/redux/actions");
const types_1 = require("src/types");
const footer_1 = __importDefault(require("src/components/footer"));
const header_1 = __importDefault(require("src/components/header"));
const branding_header_1 = __importDefault(require("src/components/branding/branding-header"));
const scroll_bar_helper_1 = __importDefault(require("src/components/scroll-bar-helper"));
const watermark_1 = __importDefault(require("src/components/watermark"));
const paginator_1 = __importDefault(require("src/components/paginator"));
const step_paginator_1 = __importDefault(require("src/components/step-paginator"));
const textDir_1 = __importDefault(require("src/hooks/textDir"));
const lang_1 = require("src/hooks/lang");
const theme_mode_1 = require("src/hooks/theme_mode");
const height_observer_1 = __importDefault(require("src/hooks/height_observer"));
const branding_1 = require("src/context/branding");
const modal_1 = require("src/context/modal");
const image_modal_1 = __importDefault(require("../image-modal"));
const notifications_1 = __importDefault(require("../notifications"));
const branding_2 = require("../branding");
const common_1 = require("./common");
const app_styles_1 = __importDefault(require("./app.styles"));
const default_styles_1 = __importDefault(require("./themes/default.styles"));
const transparent_styles_1 = __importDefault(require("./themes/transparent.styles"));
const ux_styles_1 = __importDefault(require("./themes/ux.styles"));
const ugc_cab_styles_1 = __importDefault(require("./themes/ugc-cab.styles"));
const common_styles_1 = __importDefault(require("./common.styles"));
const y_components_styles_1 = __importDefault(require("./y-components.styles"));
const markdown_styles_1 = __importDefault(require("./markdown.styles"));
const morda_styles_1 = __importDefault(require("./morda.styles"));
const b = b_1.default.with('app');
// eslint-disable-next-line max-statements, complexity
function App({ children, ProgressBarComponent = () => { } }) {
    const { background = null, branding, demoMode = false, displayMode = null, showFooter = true, showPagination = false, showProgressBar = false, showHeader = false, theme = 'default', pages, displayHiddenQuestions, pagesDisplayed, surveyPreset
    // eslint-disable-next-line max-statements
     } = (0, react_redux_1.useSelector)((state) => {
        const { pages } = state;
        const { branding: brandingConfig, demoMode, displayHiddenQuestions, surveyPreset, supportDarkMode } = state.survey;
        const branding = brandingConfig && !supportDarkMode
            ? Object.assign(Object.assign({}, brandingConfig), { darkTheme: undefined }) : brandingConfig;
        const isFinishPage = pages.currentPage === -1;
        const { background, displayMode, header, footer, pagination, progressBar, theme } = (0, selectors_1.getConfig)(state);
        const showPagination = pagination.enable && !isFinishPage;
        const showFooter = footer.enable;
        const showProgressBar = progressBar.enable;
        const showHeader = header.enable;
        const visiblePagesOnly = pages.list.filter(page => page.visible);
        const pagesDisplayed = displayHiddenQuestions ? pages.list : visiblePagesOnly;
        return {
            background,
            branding,
            demoMode,
            displayMode,
            showFooter,
            showHeader,
            showPagination,
            showProgressBar,
            theme,
            pages,
            displayHiddenQuestions,
            pagesDisplayed,
            surveyPreset
        };
    });
    const isDemoModeWithHeader = showHeader && demoMode;
    const dispatch = (0, react_redux_1.useDispatch)();
    const appRef = (0, react_2.useRef)(null);
    const [showModal, setShowModal] = (0, react_2.useState)(false);
    const [url, setUrl] = (0, react_2.useState)(null);
    const progressProps = (0, common_1.useProgressBarProps)();
    const style = background ? { '--theme-color': background, backgroundColor: background } : null;
    (0, textDir_1.default)();
    (0, lang_1.useSetLang)();
    (0, height_observer_1.default)(appRef);
    (0, theme_mode_1.useSetThemeMode)();
    const brandingHidesProgressBar = branding && branding.progressBar && branding.progressBar.hide;
    const showImageModal = (imageUrl) => {
        setUrl(imageUrl);
        setShowModal(true);
    };
    const PaginatorComponent = theme === 'ux' ? step_paginator_1.default : paginator_1.default;
    return ((0, jsx_runtime_1.jsx)(branding_1.BrandingContextProvider, Object.assign({ value: branding }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b({ theme, withHeader: isDemoModeWithHeader }), style: style, ref: appRef }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: y_components_styles_1.default }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: markdown_styles_1.default }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: common_styles_1.default }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: default_styles_1.default }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: transparent_styles_1.default }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: ux_styles_1.default }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: ugc_cab_styles_1.default }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: app_styles_1.default }), surveyPreset === types_1.SurveyPreset.YandexMorda && (0, jsx_runtime_1.jsx)(react_1.Global, { styles: morda_styles_1.default }), branding && (0, jsx_runtime_1.jsx)(branding_2.BrandingStyles, { branding: branding }), (0, jsx_runtime_1.jsx)(branding_header_1.default, { logo: branding === null || branding === void 0 ? void 0 : branding.logo, withHeader: isDemoModeWithHeader }), showPagination && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('paginator') }, { children: (0, jsx_runtime_1.jsx)(PaginatorComponent, Object.assign({}, theme)) }))), isDemoModeWithHeader && ((0, jsx_runtime_1.jsx)(header_1.default, { pages: pages, displayHiddenQuestions: displayHiddenQuestions, setDisplayHiddenQuestions: () => dispatch((0, actions_1.toggleHiddenQuestionsDisplay)()), pagesDisplayed: pagesDisplayed })), (0, jsx_runtime_1.jsx)(modal_1.ModalProvider, Object.assign({ value: {
                        showImageModal,
                        displayHiddenQuestions,
                        isDemo: isDemoModeWithHeader,
                        surveyPreset
                    } }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('body') }, { children: children })) })), showFooter && ((0, jsx_runtime_1.jsx)(footer_1.default, { legalText: branding === null || branding === void 0 ? void 0 : branding.legalText, footerLinks: branding === null || branding === void 0 ? void 0 : branding.footerLinks })), showProgressBar && !brandingHidesProgressBar && surveyPreset !== 'yandexMorda' && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('progress-bar') }, { children: (0, jsx_runtime_1.jsx)(ProgressBarComponent, Object.assign({}, progressProps)) }))), (0, jsx_runtime_1.jsx)(scroll_bar_helper_1.default, { displayMode: displayMode }), demoMode && (0, jsx_runtime_1.jsx)(watermark_1.default, {}), (0, jsx_runtime_1.jsx)(image_modal_1.default, { setShowModal: setShowModal, url: url, showModal: showModal }), (0, jsx_runtime_1.jsx)(notifications_1.default, {})] })) })));
}
exports.default = App;
